<template>
  <nav class="pagination is-centered mt2">
    <ul class="pagination-list">
      <li v-for="page in range">
        <a
          :class="[
            'pagination-link',
            { 'is-current': page === parseInt(current, 10) }
          ]"
          @click.prevent="onClick(page)"
        >
          {{ page }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import _ from "lodash";

export default {
  name: "pager",

  props: ["current", "total", "onClick"],

  computed: {
    range() {
      return _.range(1, parseInt(this.$props.total, 10) + 1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
